var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('privs-list',{ref:"privInfo",staticStyle:{"margin-bottom":"15px"},attrs:{"data":_vm.privData}}),_c('Privs-Form',{ref:"privsForm",attrs:{"privData":_vm.privData},on:{"submit":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }